/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { RoleModelDto } from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class RolesClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags Roles
   * @name RolesGetAll
   * @summary Returns the roles.
   * @request GET:/roles
   */
  rolesGetAll = (params: RequestParams = {}) =>
    this.http.request<RoleModelDto[], any>({
      path: `/roles`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Roles
   * @name RolesPost
   * @summary Create the passed role.
   * @request POST:/roles
   */
  rolesPost = (data: RoleModelDto, params: RequestParams = {}) =>
    this.http.request<RoleModelDto, any>({
      path: `/roles`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Roles
   * @name RolesGet
   * @summary Returns the role for the specified Id.
   * @request GET:/roles/{id}
   */
  rolesGet = (id: number, params: RequestParams = {}) =>
    this.http.request<RoleModelDto, any>({
      path: `/roles/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Roles
   * @name RolesPut
   * @summary Update the passed role.
   * @request PUT:/roles/{id}
   */
  rolesPut = (id: number, data: RoleModelDto, params: RequestParams = {}) =>
    this.http.request<RoleModelDto, any>({
      path: `/roles/${id}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Roles
   * @name RolesDelete
   * @summary Delete the role for the specified Id.
   * @request DELETE:/roles/{id}
   */
  rolesDelete = (id: number, params: RequestParams = {}) =>
    this.http.request<boolean, any>({
      path: `/roles/${id}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
}
